import React, { useMemo } from 'react'
import CheckmarxOneMappingForm from './CheckmarxOneMappingForm';
import CheckmarxOneCredentialForm from './CheckmarxOneCredentialForm';
import GenericPullConfigListing from '../GenericPullConfigListing';
import { columnRenderArrayData } from "utils/tableUtils";
import { useFeatureFlag } from "contexts/FeatureFlagContext";

export default function CheckmarxOneConfigListing(props) {

    const featureFlags = useFeatureFlag();

    const columns = useMemo(
    () => [
            {
                title: "Project",
                dataIndex: "projectName",
                width: 150,
                render: columnRenderArrayData,
            },
            ...(featureFlags.ENABLE_CHECKMARXONE_SCAN_FILTERS ? [{
                title: "Branch",
                dataIndex: "branch",
                width: 130,
                render: (branch) =>  columnRenderArrayData(branch),
            }] : [])
        ]
    ,[featureFlags.ENABLE_CHECKMARXONE_SCAN_FILTERS],
    );

    return (
        <GenericPullConfigListing
            {...props}
            toolName={props.name}
            MappingForm={CheckmarxOneMappingForm}
            CredentialsForm={CheckmarxOneCredentialForm}
            triggerModifyParam={triggerModifyParam}
            extraColumns={columns}
        />
    )
}

const triggerModifyParam = (record) => {
    return {
        toolConfigId: record.id
    }
}